import styled from '@emotion/styled';

const MFRWrapper = styled('div')({
  fontSize: '2.4rem',
  fontWeight: 'bold',
  lineHeight: '3rem',
});

export default MFRWrapper;
